module.exports = __webpack_public_path__ + "static/media/chrome.c3625a26.png";